// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__aUvHH","buttons":"Password_buttons__CurkE"};